import { z } from "zod"

const urlSchema = z.string().optional()

export const personPersonalizationSchema = z.object({
  userName: z.string().optional(),
  userDescription: z.string().optional(),
  userProfileImage: z.string().optional(),
  companyName: z.string().optional(),
  companyDescription: z.string().optional(),
  companyProfileImage: z.string().optional(),
  userFacebookUrl: urlSchema,
  userTwitterUrl: urlSchema,
  userLinkedinUrl: urlSchema,
  userInstagramUrl: urlSchema,
  companyFacebookUrl: urlSchema,
  companyTwitterUrl: urlSchema,
  companyLinkedinUrl: urlSchema,
  companyInstagramUrl: urlSchema,
})

export type PersonPersonalizationSchema = z.infer<typeof personPersonalizationSchema>
